/**
 * aeterna/generator.ts — Response Generation Bridge
 *
 * Delegates to the VERSE pipeline (verse/index.ts).
 *
 * VERSE: Vowel-Echo Response Synthesis Engine
 * Architecture: Kernel Extraction → Morphological Operators →
 *   Discourse Threading → Prosodic Signature → Assembly
 *
 * The response grows from the player's own words, transformed
 * through mathematical operations. Not templates. Not an LLM.
 * The player's language, reflected back through a mind.
 */

import { generateResponse as verseGenerate, type GeneratorContext } from "./verse/index.js";

export type { GeneratorContext };

/**
 * Generate the Aeterna's offline response.
 *
 * This is the entry point called by the conductor. It delegates
 * entirely to the VERSE pipeline.
 */
export function generateResponse(ctx: GeneratorContext): string {
  return verseGenerate(ctx);
}
